import type React from 'react';

export default function focusRef(
  ref: React.MutableRefObject<HTMLElement | null>,
): void {
  ref?.current?.focus();
}
